import { Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscriber, Subscription, Observable, fromEvent } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { HpService } from 'projects/hp-api/src/lib/services/hp.service';
import { Product } from '../interfaces/product';
import { WizardHpBaseComponent } from 'projects/hp-api/src/lib/base/wizard/wizard-hp-base-component';

export let browserRefresh = false;


@Component({
  selector: 'app-produits',
  templateUrl: './catalogues.component.html',
  styleUrls: ['./catalogues.component.scss']
})
export class CataloguesComponent extends WizardHpBaseComponent implements OnInit {
  product_selected = -1;

  constructor(chgDetectorRef: ChangeDetectorRef, hpService: HpService, router: Router) {

    super(chgDetectorRef, hpService, router);
   
    this.getHpService().setHeaderIn(true);
    this.getHpService().setEtape_final(false);
    this.getHpService().setBooleanParam("loadCatalo",false);
    this.getHpService().setCurrentPage(this.getIndexNextUrl('catalogues'));
    this.getHpService().setPreviousPage('selecteur-maisons'); 
     

  }

  ngOnInit() {
    

  }
  createProduct(item,i,id)
  {
    debugger;
  let catalog = {"catalog":item, "navCat_index":i,"produc_index":0 }
  this.getHpService().setCatalogIndex(i);
  this.getHpService().updateListCatalog(0,catalog);
   this.getHpService().setListCatalog(catalog);
   this.getHpService().setBooleanParam("isPagecatalog",true);
   this.getHpService().loadMultiConfig(i,0); 

   let me = this;
   this.getHpService().initToken().then(function (result) { 
   me.getHpService().doInitDirectMultiProduct(i,0).then(function (result) { 
    me.product_selected = item.id;
   
    me.getHpService().emitDataChange();
    me.getChangeDetectorRef().detectChanges();
 });  
 
 });
 
 }
   

  /**
  * Load Product */
 loadProduct(item:any,i)
 {
  this.getHpService().setBooleanParam("loadCatalo",false);
  this.getHpService().setBooleanParam("isPagecatalog",true);
  this.getChangeDetectorRef().detectChanges()
  this.getHpService().emitDataChange();
  let catalog = {"catalog":item, "navCat_index":i,"produc_index":0}
  this.getHpService().setCatalogIndex(i);
  this.getHpService().updateListCatalog(0,catalog);
  this.getHpService().loadMultiConfig(i,0); 
  this
  let me = this;
  this.getHpService().initToken().then(function (result) { 
  me.getHpService().doInitDirectMultiProduct(i,0).then(function (result) { 
  me.product_selected = item.id;
  me.getChangeDetectorRef().detectChanges()
  me.getHpService().emitDataChange();  
});   
});
}
  
}
